import { useCallback, useMemo, useState } from "react";

import { normalizeLabel } from "../lib/labels";

// INDETERMINADO gestiona un único producto: el formulario captura solo los datos
// que Implementación / Técnica puede diligenciar. El resto (precios, valores de
// mercado) lo completa Sub. Operativa más adelante.
const EMPTY_FORM = {
  productName: "",
  technicalSpec: "",
  unit: null, // opción { value, label } de AppSelect
  brand: "",
};

const isFormComplete = (form) =>
  Boolean(
    form &&
      form.productName.trim() &&
      form.technicalSpec.trim() &&
      form.unit?.value != null &&
      form.brand.trim()
  );

export const useIndeterminateManagement = ({
  row,
  assignment,
  managementTypeOptions = [],
} = {}) => {
  const [observation, setObservation] = useState("");
  const [form, setForm] = useState(EMPTY_FORM);

  const setField = useCallback((field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  }, []);

  const isComplete = useMemo(() => isFormComplete(form), [form]);
  const canSubmit = isComplete && Boolean(observation.trim());

  // tipo_gestion_id de la gestión actual: se resuelve igual que en la vista
  // estándar (código del renglón o coincidencia por etiqueta).
  const managementTypeId = useMemo(() => {
    const code = row?.managementTypeCode ?? assignment?.selectedRows?.[0]?.managementTypeCode;
    if (code != null) return code;

    const match = managementTypeOptions.find(
      (opt) => normalizeLabel(opt.label) === normalizeLabel(assignment?.managementType)
    );
    return match?.value ?? null;
  }, [row, assignment, managementTypeOptions]);

  // Filas listas para los dos recursos de envío (gestión + solicitud). Cada fila
  // lleva los datos del nuevo producto en `indeterminateProduct`, que
  // buildProductoPayload traduce a nombre_producto/especificacion_tecnica/unidad/marca.
  const buildSelectedRows = useCallback(() => {
    if (!row) return [];
    return [
      {
        ...row,
        indeterminateProduct: {
          nombre_producto: form.productName.trim(),
          especificacion_tecnica: form.technicalSpec.trim(),
          unidad: form.unit?.value != null ? Number(form.unit.value) : 0,
          marca: form.brand.trim(),
        },
      },
    ];
  }, [row, form]);

  return {
    observation,
    setObservation,
    form,
    setField,
    isComplete,
    canSubmit,
    managementTypeId,
    buildSelectedRows,
  };
};